var map = {
	"./music-instructions.json": 4318,
	"./music-library-intro2024.json": 4319,
	"./music-library-launch2024.json": 4320,
	"./music-progression.json": 4321,
	"./startSourcesAdvanced.json": 4322,
	"./startSourcesSimple.json": 4323,
	"./startSourcesSimple2.json": 4324,
	"./startSourcesTracks.json": 4325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4057;